import { useTranslation } from 'react-i18next'

/** The prototype's `.notif-empty`: a teal check-circle over "No notifications".
 * Shown by the top-bar dropdown when nothing is active (PO Q4,
 * ARCHITECTURE_DECISIONS.md §49) — the only notification surface since Home
 * lost its notification centre (MS-996, §53). */
export function NotificationsEmpty() {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col items-center gap-2.5 px-5 py-8 text-center text-[13px] text-[var(--text-tertiary)]">
      <svg
        viewBox="0 0 24 24"
        width={28}
        height={28}
        fill="none"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-teal-500"
        aria-hidden="true"
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
      <span>{t('notifications.empty')}</span>
    </div>
  )
}
